import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getRightsForUser } from '../constants/majeeRights';

export default function useMajeeRights() {
  const { userAuth } = useSelector((state) => state.auth);
  return useMemo(
    () => getRightsForUser(userAuth?.division || []),
    [userAuth?.division],
  );
}
